import { MailRibbonTabId } from 'owa-ribbon-ids';

enum ContextualRibbonTab {
    Tab_Table_Format = MailRibbonTabId.Tab_Table_Format,
}

export default ContextualRibbonTab;
